import React from 'react'

import { IconBase, IconProps } from '@/components/Icons'

export const RoundedRectangle: React.FC<IconProps> = (props) => (
  <IconBase {...props} viewBox="0 0 40 40">
    <path
      d="M0 20C0 8.95431 8.9543 0 20 0H21.3333C31.6427 0 40 8.35735 40 18.6667C40 30.4487 30.4488 40 18.6667 40H0V20Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0"
      vectorEffect="non-scaling-stroke"
    />
  </IconBase>
)
